import { useField } from 'formik'
import React, { useEffect, useRef } from 'react'
import { Select, Form } from 'semantic-ui-react'
import { SelectItem } from '../../models/SelectIem'
import FWOLabel from './FWOLabel'

interface Props {
  placeholder?: string
  name: string
  className?: string
  options: SelectItem[]
  label?: string
  required: boolean
  onChange?: (field, value) => void
  loading: boolean
  tooltip?: string
  showreadonly?: boolean
  showOptional?: boolean
  clearSelection?: boolean
  title?: string
  onSelection?: (any) => void
}

const FWOSelectInput = (props: Props) => {
  const mountedRef = useRef(false)
  const [field, meta, helpers] = useField(props.name)
  const hasError =
    meta.touched && (field.value === null || field.value === '') && !!meta.error
  useEffect(() => {
    mountedRef.current = true
    if (
      mountedRef.current &&
      props.clearSelection !== undefined &&
      props.clearSelection === true
    ) {
      helpers.setValue('')
    }
    return () => {
      mountedRef.current = false
    }
  }, [props.clearSelection])

  return (
    <Form.Field error={hasError} {...{ required: props.required }}>
      <div className={`sixteen wide field`}>
        <FWOLabel
          label={props.label}
          name={props.name}
          tooltip={props.tooltip}
          showOptional={props.showOptional}
          required={props.required}
        />
        {hasError ? (
          <span className="validation-error">{meta.error}</span>
        ) : null}
        <Select
          className={props.className}
          loading={props.loading}
          clearable
          options={props.options}
          value={field.value || null}
          aria-label={hasError ? props.label + meta.error : props.label}
          onChange={
            props.onChange
              ? props.onChange
              : (e, d) => {
                  helpers.setValue(d.value)
                  if (props.onSelection) {
                    props?.onSelection(d.value)
                  }
                }
          }
          onBlur={() => helpers.setTouched(true)}
          placeholder={props.placeholder}
          {...{ disabled: props.showreadonly == true }}
          title={props.title}
        />
      </div>
    </Form.Field>
  )
}

export default FWOSelectInput
